import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

// Hosts can type any ticket name; these are offered as shortcuts.
const SUGGESTIONS = ["Early Bird", "Ordinary", "VIP", "VVIP"];
const MAX_LENGTH = 50;

const TicketNameField = ({ value, onChange, takenNames = [], className }) => {
  const taken = takenNames.map((name) => (name || "").trim().toLowerCase());
  return (
    <Autocomplete
      freeSolo
      disableClearable
      options={SUGGESTIONS.filter(
        (name) => !taken.includes(name.toLowerCase()),
      )}
      value={value || ""}
      inputValue={value || ""}
      onInputChange={(_, next) => onChange(next)}
      style={{ flex: 1 }}
      renderInput={(params) => (
        <TextField
          {...params}
          className={className}
          variant="outlined"
          label="Ticket name"
          placeholder="e.g. Golden Circle"
          inputProps={{ ...params.inputProps, maxLength: MAX_LENGTH }}
        />
      )}
    />
  );
};

// Returns a message describing what's wrong with the ticket names, or null.
export const ticketNamesProblem = (tickets) => {
  const names = tickets.map((t) => (t.ticket_name || "").trim());
  if (names.some((name) => !name)) return "Give every ticket a name.";
  const lower = names.map((name) => name.toLowerCase());
  const duplicate = names.find((_, i) => lower.indexOf(lower[i]) !== i);
  if (duplicate)
    return `"${duplicate}" is used more than once. Give each ticket its own name.`;
  return null;
};

export const withTrimmedNames = (tickets) =>
  tickets.map((t) => ({ ...t, ticket_name: (t.ticket_name || "").trim() }));

export default TicketNameField;
